export default function capitalizeFirstLetter(value: string): string {
  return value[0].toUpperCase() + value.slice(1);
}
